import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('PWA installed! App is now available offline.');
    }
  },
  onUpdate: (registration) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('New version available! Refresh to update.');
    }
    if (window.confirm('New version available! Reload to update?')) {
      window.location.reload();
    }
  }
});
